<script setup>
import { computed, ref } from "vue";

const props = defineProps({
    onLabel: String,
    offLabel: String,
    modelValue: Boolean,
});

const emit = defineEmits(["update:modelValue"]);

const sweeperRef = ref(null);
const offLabelRef = ref(null);
const onLabelRef = ref(null);

const isOn = ref(props.modelValue ?? false);

const sweeperStyle = computed(() => {
    const elRef = isOn.value ? onLabelRef : offLabelRef;
    const rect = elRef.value?.getBoundingClientRect();
    if (!rect) {
        return {};
    }

    const width = rect.width;
    const height = rect.height;
    const left = elRef.value.offsetLeft;
    const top = elRef.value.offsetTop;
    const space = 4;
    return {
        left: left - space + "px",
        top: top - space + "px",
        width: width + space * 2 + "px",
        height: height + space * 2 + "px",
        transition: "all 0.2s ease-in-out",
    };
});

function toggle(val) {
    isOn.value = val;
    emit("update:modelValue", val);
    const customEvent = new CustomEvent("app-switch.update:modelValue", {
        detail: {
            value: val,
        },
    });
    document.dispatchEvent(customEvent);
}
</script>

<template>
    <div
        class="
            inline-flex
            items-center
            relative
            p-2
            rounded-full
            gap-2
            bg-gray-300
        "
    >
        <div
            class="absolute bg-accent rounded-full z-0"
            :style="sweeperStyle"
            ref="sweeperRef"
        ></div>

        <div
            ref="offLabelRef"
            class="p-2 cursor-pointer relative z-1 transition-all"
            :class="{
                'text-white': !isOn,
            }"
            @click="toggle(false)"
        >
            {{ offLabel }}
        </div>
        <div
            ref="onLabelRef"
            class="p-2 cursor-pointer relative z-1 transition-all"
            :class="{
                'text-white': isOn,
            }"
            @click="toggle(true)"
        >
            {{ onLabel }}
        </div>
    </div>
</template>

<style scoped></style>
